(function () {
  function init() {
    var dataNode = document.getElementById('LucceGloboTotalData');
    if (!dataNode) return;
    var data = JSON.parse(dataNode.textContent);

    document.querySelectorAll('[id^="ProductSection-"]').forEach(function (root) {
      if (root.dataset.globoTotalReady) return;
      root.dataset.globoTotalReady = 'true';
      var row;
      var amount;
      var frame;
      var variantId = data.variantId;
      var unavailable = false;

      function visible(element) {
        return element.getClientRects().length > 0 && !element.closest('[hidden]');
      }

      function update() {
        frame = null;
        var app = root.querySelector('.gpo-app, .globo-product-options, #globo-product-options');
        var controls = app && app.querySelectorAll('select, input:not([type="hidden"]), textarea');
        if (!app || !controls.length || !visible(app)) {
          if (row) row.hidden = true;
          return;
        }
        if (!row) {
          row = document.createElement('div');
          row.className = 'lucce-globo-total';
          row.hidden = true;
          row.setAttribute('role', 'status');
          row.setAttribute('aria-live', 'polite');
          row.setAttribute('aria-atomic', 'true');
          var label = document.createElement('span');
          label.textContent = 'Total Price';
          amount = document.createElement('span');
          row.append(label, amount);
        }
        var submit = root.querySelector('.product-form__cart-submit');
        var anchor = submit && (submit.closest('.product-form__controls-group--submit') || submit);
        if (anchor) {
          if (anchor.previousElementSibling !== row) anchor.before(row);
        } else if (app.nextElementSibling !== row) app.after(row);

        var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
        var selectedId = idInput && idInput.value ? idInput.value : variantId;
        var variant = data.variants.find(function (item) { return String(item.id) === String(selectedId); });
        var formatter = window.LucceCurrencyFormatter;
        if (unavailable || !variant || !formatter || !formatter.isCurrencyReady()) {
          row.hidden = true;
          return;
        }
        var base = variant.price / 100;
        if (data.currency !== 'PHP') {
          var state = formatter.getState();
          if (!state || state.code !== data.currency) {
            row.hidden = true;
            return;
          }
          base = formatter.selectedToPhpAmount(base);
        }
        var addon = 0;
        controls.forEach(function (control) {
          if (control.disabled || !visible(control.closest('.gpo-element') || control)) return;
          if (control.tagName === 'SELECT') {
            Array.from(control.selectedOptions).forEach(function (option) {
              addon += Number(option.getAttribute('data-addon-price')) || 0;
            });
          } else if (control.type === 'radio' || control.type === 'checkbox') {
            if (control.checked) addon += Number(control.getAttribute('data-addon-price')) || 0;
          } else if (control.value.trim()) {
            addon += Number(control.getAttribute('data-addon-price')) || 0;
          }
        });
        var text = formatter.formatPhpPrice(Math.round((base + addon) * 100) / 100);
        if (amount.textContent !== text) amount.textContent = text;
        row.hidden = false;
      }

      function schedule() {
        if (!frame) frame = window.requestAnimationFrame(update);
      }

      root.addEventListener('input', schedule);
      root.addEventListener('change', schedule);
      root.addEventListener('variantChange', function (event) {
        unavailable = !event.detail.variant;
        if (!unavailable) variantId = event.detail.variant.id;
        schedule();
      });
      document.addEventListener('lucce:currency:updated', schedule);
      new MutationObserver(function (records) {
        if (records.some(function (record) { return !row || !row.contains(record.target); })) schedule();
      }).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-addon-price', 'checked', 'selected', 'disabled', 'hidden', 'style', 'class', 'value']
      });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
